module.exports = __webpack_public_path__ + "img/water_spring_small.1a278af7.png";